import moment from 'moment';
import PolicySearchUtil from 'gw-portals-util-angular/PolicySearchUtil';
import CurrencyUtil from 'edge/gateway/util/CurrencyUtil';
import templateStr from 'text!./job-summary.html';

export default ['$filter', function ($filter) {
    return {
        restrict: 'A',
        transclude: true,
        template: templateStr,
        scope: {
            accountNumber: '@',
            config: '='
        },
        controller: ['$q', '$scope', '$state', 'JobService', 'ModalService', 'InsuranceSuiteMetadata', function ($q, $scope, $state, JobService, ModalService, InsuranceSuiteMetadata) {
            $scope.failedToGetJobs = false;
            $scope.loading = true;
            var jobs = [];

            init();

            function init() {
                if (!$scope.config) {
                    $scope.config = {
                        jobStatus: 'Open - Not Bound',
                        defaultJobStatus: 'Open - Not Bound',
                        issuedInLastXDays: 30,
                        jobStatusOptions: ['Open - Bound', 'Open - Not Bound', 'Issued in Last 30 Days'],
                        source: 'user'
                    };
                }

                var submissionsPromise = getJobsFromXCenter();
                $scope.submissionsPromise = submissionsPromise;

                $q.when(submissionsPromise, function (submissions) {
                    jobs = submissions;
                    $scope.loading = false;
                }, function () {
                    $scope.failedToGetJobs = true;
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
                });
            }

            function getJobsFromXCenter() {
                if ($scope.config.source === 'user') {
                    return findSubmissionByCreateUserOpenedWithinNumberOfDays($scope.config.issuedInLastXDays);
                } else if ($scope.config.source === 'account') {
                    return findSubmissionSummariesByAccount($scope.accountNumber);
                }
            }

            function findSubmissionByCreateUserOpenedWithinNumberOfDays(numberOfDays) {
                return JobService.findSubmissionByCreateUserOpenedWithinNumberOfDays(numberOfDays);
            }

            function findSubmissionSummariesByAccount(accountNumber) {
                return JobService.findSubmissionSummariesByAccount(accountNumber);
            }

            $scope.getFilteredJobs = function () {
                var filteredJobs = jobs;
                if ($scope.config.search) {
                    filteredJobs = $filter('filter')(filteredJobs, jobSearchFilter);
                }
                if ($scope.config.jobStatus) {
                    filteredJobs = $filter('filter')(filteredJobs, filterByStatus);
                }
                return filteredJobs;
            };

            /**
             * Custom search filter for Jobs
             *
             * @param {Object} job
             * @returns {Boolean} - true if the filter string matches the job's create time, job number, or accountholder name, otherwise false
             */
            function jobSearchFilter(job) {
                var lowerCaseSearch = angular.lowercase($scope.config.search);
                return angular.lowercase($filter('date')(job.createTime, 'shortDate')).indexOf(lowerCaseSearch || '') !== -1 || angular.lowercase(job.namedInsured).indexOf(lowerCaseSearch || '') !== -1 || angular.lowercase(job.jobNumber).indexOf(lowerCaseSearch || '') !== -1 || angular.lowercase(job.status).indexOf(lowerCaseSearch || '') !== -1 || !$scope.hideAccount() && job.accountHolderName.indexOf(lowerCaseSearch || '') !== -1;
            }

            function filterByStatus(submission) {
                // Issued in last 30 days
                if ($scope.config.jobStatus === 'last30Days' && submission.policyIssued && isIssuedInLastXDays(submission, $scope.config.issuedInLastXDays)) {
                    submission.status = $scope.getJobStatus(submission);
                    return true;
                } else if ($scope.config.jobStatus === 'openBound') {
                    // Open - bound
                    return submission.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Bound').name && (!submission.policyIssued || !angular.isDefined(submission.closeDate));
                } else if ($scope.config.jobStatus === 'openNotBound') {
                    return submission.status !== InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Bound').name && !angular.isDefined(submission.closeDate);
                }
                return false;
            }

            function isIssuedInLastXDays(submission, days) {
                return moment().isSame(submission.closeDate, 'day') || moment(submission.closeDate).isAfter(moment().subtract(days, 'days'), 'day');
            }

            $scope.hideAccount = function () {
                return $scope.config.source === 'account';
            };

            $scope.getPolicyTypeIcon = PolicySearchUtil.getPolicyTypeIconPath;

            $scope.getCurrency = function (currencyType) {
                return CurrencyUtil.getCurrencySymbol(currencyType);
            };

            $scope.goToPolicySummary = function (policyNumber) {
                $state.go('viewPolicy', {
                    policyNumber: policyNumber
                });
            };

            $scope.getJobStatus = function (submission) {
                if (submission.policyIssued) {
                    return $filter('translate')('gateway.directives.JobSummary.Issued');
                } else if (submission.status === 'Not-taken') {
                    return $filter('translate')('gateway.directives.JobSummary.Not Taken');
                }
                return submission.status;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/JobSummaryDirective/JobSummary.js
// module id = 1748
// module chunks = 0